// extracted by mini-css-extract-plugin
export var equalColumn = "_e7-0";